import * as React from 'react';
import Container from '@mui/material/Container';

export default function PageContainer(props) {
  return (
    <Container maxWidth="xl" sx={{position:'relative', pb:7}}>{props.children}</Container>
  );
}